import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// Where the sign-in popup lands after Entra (lib/sessionExpiry.ts). The session
// cookie is set by then; the opener notices the popup closing and carries on.
// Opened directly (no opener) it just goes to the dashboard.
export const Route = createFileRoute("/session-renewed")({
  component: SessionRenewed,
});

function SessionRenewed() {
  const { t } = useTranslation();
  useEffect(() => {
    if (window.opener) window.close();
    else window.location.replace("/dashboard");
  }, []);
  return (
    <div data-screen-label="Session Renewed">
      <p style={{ padding: "var(--space-6)" }}>{t("session.renewed")}</p>
    </div>
  );
}
